import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/newhome/splitbanner/diagonal-arrow.svg")